/* eslint-disable */
// 引入手机号极验
import Vue from 'vue'
require('~/assets/js/geetest.js')
Vue.prototype.$initGeet = initGeetest4
